import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom"; // 🆕 useLocation importálása
import Markdown from "markdown-to-jsx";
import axios from "axios";

const Article = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 🆕 Az adatok lekérése
  const { artID, language } = location.state || {}; // 🆕 Ha nincs adat, akkor undefined helyett üres objektum
  const [markdownContent, setMarkdownContent] = useState("");
  const topButtonRef = useRef(null);

  useEffect(() => {
    console.log("Lekért ArtID:", artID);
    console.log("Nyelv:", language);
    //console.log(markdownContent);

    // API kérés a markdown tartalomhoz
    axios
      .get(`http://217.13.111.96:5000/api/markdown`, {
        params: {
          artid: artID,
          lang: language,
        },
      })
      .then((response) => {
        console.log("Az articlesMysql tábla tartalma:", response.data);
        if (response.data.length > 0) {
          setMarkdownContent(response.data[0].content); // Beállítjuk a tartalmat
        }
      })
      .catch((error) => {
        console.error("Hiba a kérés során:", error);
      });
  }, [artID, language]); // 🆕 Az `artID` és `language` változására újra lefut az API kérés

  useEffect(() => {
    const mybutton = topButtonRef.current;
    if (!mybutton) return;

    const scrollFunction = () => {
      mybutton.style.display = window.scrollY > 100 ? "block" : "none";
    };

    const topFunction = () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    window.addEventListener("scroll", scrollFunction);
    mybutton.addEventListener("click", topFunction);

    return () => {
      window.removeEventListener("scroll", scrollFunction);
      mybutton.removeEventListener("click", topFunction);
    };
  }, []);

  if (!markdownContent) {
    return (
      <div className="main-content article-content px-4 md-3">
        <p>Nincs megjeleníthető tartalom.</p>
      </div>
    );
  }

  return (
    <div className="main-content article-content px-4 md-3">
      {/* "Go to top" gomb */}
      <button
        ref={topButtonRef}
        id="TopBtn"
        title="Go to top"
        style={{ display: "none" }}
      >
        &#10224;
      </button>

      {/* Markdown tartalom megjelenítése */}
      <Markdown>{markdownContent}</Markdown>

      {/* Vissza gomb */}
      <button onClick={() => navigate(-1)} className="btn btn-secondary my-3">
        Vissza
      </button>
    </div>
  );
};

export default Article;
